"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentBenefits = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _models = require("../models");
var _utils = require("../utils");
var _BaseIcon = require("./BaseIcon");
var _jsxRuntime = require("react/jsx-runtime");
const displayFlex = 'flex';
const contentStart = 'flex-start';
const RootContainer = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  position: 'relative',
  width: '100%',
  maxWidth: '100%',
  maxHeight: '100%',
  background: theme.palette.offer.light,
  padding: theme.spacing(6, 3, 6, 3),
  alignSelf: 'auto',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(10),
    maxWidth: '360px',
    height: 'auto',
    alignSelf: 'baseline',
    borderRadius: '15px'
  }
}));
const StyledItem = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  display: displayFlex,
  justifyContent: contentStart,
  alignItems: contentStart,
  padding: theme.spacing(1, 0, 4, 0)
}));
const StyledBoxInfo = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: displayFlex,
  justifyContent: contentStart,
  alignItems: 'center',
  flexWrap: 'wrap',
  marginLeft: theme.spacing(3)
}));
const StyledBoxTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'left',
  fontWeight: 'bold',
  fontSize: '17px',
  color: theme.palette.text.primary
}));
const BenefitsTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'center',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(5)
}));
const StyledBoxDescription = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'left',
  width: '100%',
  color: theme.palette.text.primary,
  marginTop: theme.spacing(2)
}));
const BenefitsExpand = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'center',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  borderBottom: `2px solid ${theme.palette.text.primary}`,
  cursor: 'pointer'
}));

// use in next task with new features
// const getCountTextLines = (reference: React.MutableRefObject<HTMLSpanElement | null>) => {
//   const customTextClientHeight = reference.current?.clientHeight ?? 0;
//   const lineHeight = reference.current
//     ? Number.parseFloat(getComputedStyle(reference.current).lineHeight)
//     : 0;

//   return Math.round(customTextClientHeight / lineHeight);
// }

const ContentBenefits = () => {
  const [isSmallDevice, setIsSmallDevice] = (0, _react.useState)(false);
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  // use in next task with new features
  // const customTextRef = useRef<HTMLSpanElement | null>(null);
  // const lines = getCountTextLines(customTextRef);

  const isMobileView = (0, _utils.useIsMobile)();
  window.addEventListener('resize', () => {
    setIsSmallDevice(isMobileView);
  }, false);
  (0, _react.useEffect)(() => {
    if (isMobileView) {
      setIsExpanded(false);
      setIsSmallDevice(true);
    } else {
      setIsExpanded(true);
    }
  }, [isMobileView]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    container: true,
    justifyContent: "space-around",
    alignItems: "center",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(BenefitsTitle, {
      variant: "h5",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Benefits_Header_Title,
        id: _models.TranslationKey.Benefits_Header_Title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledItem, {
      size: {
        xs: 12
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BaseIcon.BaseIcon, {
        iconName: (0, _contexts.GetContent)(_Localization.ContentKeys.Benefit_Icon1),
        defaultIconName: "DiscountTag"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBoxInfo, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxTitle, {
          variant: "body1",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Benefits_Title1,
            id: _models.TranslationKey.Benefits_Title1
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
          in: isExpanded,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxDescription
          // use in next task with new features
          // ref={customTextRef}
          , {
            variant: "body1"
            // use in next task with new features
            // sx={
            //   lines >= 4
            //     ? {
            //         overflow: 'hidden',
            //         textOverflow: 'ellipsis',
            //         display: '-webkit-box',
            //         '-webkit-line-clamp': '4',
            //         '-webkit-box-orient': 'vertical',
            //       }
            //     : null
            // }
            ,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.Benefits_Text1,
              id: _models.TranslationKey.Benefits_Text1
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledItem, {
      size: {
        xs: 12
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BaseIcon.BaseIcon, {
        iconName: (0, _contexts.GetContent)(_Localization.ContentKeys.Benefit_Icon2),
        defaultIconName: "Cashback"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBoxInfo, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxTitle, {
          variant: "body1",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Benefits_Title2,
            id: _models.TranslationKey.Benefits_Title2
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
          in: isExpanded,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxDescription, {
            variant: "body1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.Benefits_Text2,
              id: _models.TranslationKey.Benefits_Text2
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledItem, {
      size: {
        xs: 12
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BaseIcon.BaseIcon, {
        iconName: (0, _contexts.GetContent)(_Localization.ContentKeys.Benefit_Icon3),
        defaultIconName: "Share"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledBoxInfo, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxTitle, {
          variant: "body1",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _constants.defaultTranslations.Benefits_Title3,
            id: _models.TranslationKey.Benefits_Title3
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
          in: isExpanded,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBoxDescription, {
            variant: "body1",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.Benefits_Text3,
              id: _models.TranslationKey.Benefits_Text3
            })
          })
        })]
      })]
    }), isSmallDevice ? /*#__PURE__*/(0, _jsxRuntime.jsx)(BenefitsExpand, {
      onClick: () => setIsExpanded(!isExpanded),
      children: isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Benefits_ShowLess,
        id: _models.TranslationKey.Benefits_ShowLess
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.Benefits_ShowMore,
        id: _models.TranslationKey.Benefits_ShowMore
      })
    }) : null]
  });
};
exports.ContentBenefits = ContentBenefits;
